
import { SidebarProvider, Sidebar, SidebarContent, SidebarMenu, SidebarMenuItem, SidebarMenuButton, SidebarFooter } from "@/components/ui/sidebar"
import { User, Grid, Users, Image, Printer, FileText, Video, Truck, Activity, Scan, LayoutGrid, DollarSign, Link } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { supabase } from "@/integrations/supabase/client"
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button"

export default function AdminLayout({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex flex-1">
        <SidebarProvider>
          <Sidebar className="border-r border-border">
            <SidebarContent>
              <div className="p-4 border-b border-border">
                <h1 className="text-xl font-bold text-primary">Artwork Registry</h1>
              </div>
              <SidebarMenu>
                <SidebarMenuItem>
                  <SidebarMenuButton asChild>
                    <a href="/" className="flex items-center">
                      <Grid className="mr-2" />
                      <span>Dashboard</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton asChild>
                    <a href="/creators" className="flex items-center">
                      <Users className="mr-2" />
                      <span>Creators</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton asChild>
                    <a href="/collections" className="flex items-center">
                      <LayoutGrid className="mr-2" />
                      <span>Collections</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton asChild>
                    <a href="/artworks" className="flex items-center">
                      <Image className="mr-2" />
                      <span>Artworks</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton asChild>
                    <a href="/prints" className="flex items-center">
                      <Printer className="mr-2" />
                      <span>Prints</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton asChild>
                    <a href="/certificates" className="flex items-center">
                      <FileText className="mr-2" />
                      <span>Certificates</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton asChild>
                    <a href="/media" className="flex items-center">
                      <Video className="mr-2" />
                      <span>Media</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton asChild>
                    <a href="/providers" className="flex items-center">
                      <Truck className="mr-2" />
                      <span>Print Providers</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton asChild>
                    <a href="/currencies" className="flex items-center">
                      <DollarSign className="mr-2" />
                      <span>Currencies</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton asChild>
                    <a href="/activity" className="flex items-center">
                      <Activity className="mr-2" />
                      <span>Activity Log</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton asChild>
                    <a href="/templates" className="flex items-center">
                      <FileText className="mr-2" />
                      <span>Templates</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton asChild>
                    <a href="/digitization" className="flex items-center">
                      <Scan className="mr-2" />
                      <span>Digitization</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton asChild>
                    <a href="/hologram-generator" className="flex items-center">
                      <FileText className="mr-2" />
                      <span>Hologram Generator</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
                <SidebarMenuItem>
                  <SidebarMenuButton asChild>
                    <a href="/webhooks" className="flex items-center">
                      <Link className="mr-2" />
                      <span>Webhook Management</span>
                    </a>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              </SidebarMenu>
            </SidebarContent>
            <SidebarFooter className="p-4">
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Button
                    variant="ghost"
                    size="icon"
                    className="w-full flex items-center justify-start px-2 py-2"
                  >
                    <User className="w-5 h-5 mr-2" />
                    <span>Account</span>
                  </Button>
                </DropdownMenuTrigger>
                <DropdownMenuContent align="end">
                  <DropdownMenuItem onClick={handleLogout}>
                    Sign out
                  </DropdownMenuItem>
                </DropdownMenuContent>
              </DropdownMenu>
            </SidebarFooter>
          </Sidebar>

          <main className="flex-1 overflow-auto p-6">
            {children}
          </main>
        </SidebarProvider>
      </div>
    </div>
  );
}
